import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { REVIEWS } from "@/data/content";
import { t } from "@/data/texts";
import { Reveal } from "@/components/effects/Effects";

const CZ_DAYS = ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"];
function fmtDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return `${CZ_DAYS[d.getDay()]} ${d.getDate()}.${d.getMonth() + 1}.`;
}

export default function Reviews() {
  const [data, setData] = useState({ total: 0, counts: {}, comments: [] });

  useEffect(() => {
    api.get("/reviews/public").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  const maxCount = Math.max(1, ...Object.values(data.counts || {}));

  return (
    <section id="recenze" className="relative bg-[#060505] border-b border-white/10" data-testid="reviews-section">
      <div className="max-w-5xl mx-auto px-5 py-20 lg:py-28">
        <Reveal>
          <p className="text-xs tracking-[0.4em] text-nv uppercase mb-3">{t("reviews.kicker", REVIEWS.kicker)}</p>
          <h2 className="font-head text-3xl sm:text-4xl text-neutral-100 mb-2 vhs-glitch">{t("reviews.title", REVIEWS.title)}</h2>
          <p className="text-sm text-neutral-500 mb-12">{t("reviews.sub", REVIEWS.sub)}</p>
        </Reveal>

        <div className="space-y-4">
          {REVIEWS.options.map((o, i) => {
            const count = (data.counts && data.counts[o.id]) || 0;
            return (
              <Reveal key={o.id} delay={i * 70}>
                <div className="border border-white/10 bg-[#0b0a09] p-4 sm:p-5 group hover:border-nv/40 transition-colors relative overflow-hidden" data-testid={`review-option-${o.id}`}>
                  <div className="flex items-center justify-between gap-4">
                    <div className="flex items-center gap-4">
                      <span className="font-head text-2xl text-[#3a2f2c] w-8">{o.id}</span>
                      <span className="font-head text-base sm:text-lg text-neutral-200">{o.label}</span>
                    </div>
                    <span className="text-xs tracking-widest text-neutral-500" data-testid={`review-count-${o.id}`}>{count}×</span>
                  </div>
                  <div className="mt-3 h-2 bg-black border border-white/10 relative">
                    <div className="absolute inset-y-0 left-0 bg-nv/40 transition-all duration-700" style={{ width: `${(count / maxCount) * 100}%` }} />
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>

        {data.comments && data.comments.length > 0 ? (
          <div className="mt-12 space-y-4" data-testid="reviews-comments">
            <p className="text-xs tracking-[0.35em] text-nv uppercase mb-2">Co říkali ti, co přežili</p>
            {data.comments.map((c, i) => (
              <Reveal key={i} delay={i * 60}>
                <blockquote className="border-l-2 border-[#4a0404] pl-5 py-2">
                  <p className="text-neutral-300 italic leading-relaxed">„{c.text}"</p>
                  <footer className="mt-2 text-xs text-neutral-600 tracking-widest">
                    — {c.first_name || "Anonym"} · {c.option_label} · {fmtDate(c.created_at)}
                  </footer>
                </blockquote>
              </Reveal>
            ))}
          </div>
        ) : (
          <Reveal>
            <div className="mt-10 text-center border border-dashed border-white/10 py-10 px-6" data-testid="reviews-empty">
              <p className="font-head text-xl text-neutral-300 mb-2">Zatím {data.total} hodnocení.</p>
              <p className="text-sm text-neutral-500">
                Recenze se objeví, jakmile hru přežijí první návštěvníci. Odkaz na hodnocení dostanou e-mailem po odehrání.
              </p>
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}
